import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';

import { Producto } from '../interfaces/producto.interface';
import { Caja } from '../interfaces/caja.interface';
import { Venta } from '../interfaces/venta.interface';
import { ToastrService } from 'ngx-toastr';
import { DteGenerado } from '../interfaces/dte-generado.interface';
import { AngularFireStorage } from '@angular/fire/storage';
import { Folio } from '../interfaces/folios.interface';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class VentaService {

  openPage = false;
  isAuthenticated = false;
  scanAuto = true;
  caja: Caja;
  productos: Producto[] = [];
  venta = 0;
  caf: File;
  cert: File;
  folio: Folio;
  impresora = '';

  constructor(
    private http: HttpClient,
    private aff: AngularFirestore,
    private afa: AngularFireAuth,
    private storage: AngularFireStorage,
    private toastr: ToastrService
  ) {

  }

  agregarProductoLista(producto: Producto, cantidad: number) {
    const index = this.productos.findIndex(
      (element) => element.barcode === producto.barcode
    );

    if (index > -1) {
      if (
        this.comprueboStock(
          this.productos[index].cantidad + cantidad,
          producto.stock
        )
      ) {
        if (producto.category !== 'PANADERIA' && producto.category !== 'VERDURERIA' && producto.category !== 'FIAMBRERIA') {
          this.productos[index].cantidad += cantidad;

        } else {
          this.productos[index].cantidad += producto.cantidad;
          this.productos[index].precio += producto.precio;
        }

      } else {
        this.toastr.error('Exede Stock.');
      }
    } else {
      if (this.productos.length === 12) {
        this.toastr.error('Alcanzo el limite de Productos (12).');
        return;
      }

      if (this.comprueboStock(cantidad, producto.stock)) {
        if (producto.category !== 'PANADERIA' && producto.category !== 'VERDURERIA' && producto.category !== 'FIAMBRERIA') {
          producto.cantidad = cantidad;
        }

        this.productos.push(producto);
      } else {
        this.toastr.error('Exede Stock.');
      }
    }
  }

  calcularTotal() {
    let total = 0;
    this.productos.forEach( (producto: Producto) => {
      if (producto.kilo! > 10) {
        total += (producto.precio * 1);
      } else {
        total += producto.precio * producto.cantidad! * 1;
      }
    });
    this.venta = total * 1;
  }

  comprueboStock(cantidad: number, stock: number): boolean {
    if (cantidad <= stock) {
      return true;
    } else {
      return true;
      //TODO: Cambiar cuando evalue stock return false
    }
  }

  auth() {
    return this.afa.signInWithEmailAndPassword('alexalvarezmarambio@gmail.com', '123456');
  }

  obtenerCaja(estado: string) {
    return this.aff.collection<Caja>('boxes', ref => ref.where('estado', '==', estado)).valueChanges({idField: 'id'});
  }

  productoPorBarra(barra: string) {
    return this.aff.collection<Producto>('products', ref => ref.where('barcode', '==', barra)).valueChanges({idField: 'id'}).pipe(take(1));
  }

  obtenerCategorias() {
    return this.aff.collection(
      'categorias',
      ref => ref
        .where('estado', '==', true)
        .orderBy('nombre', 'asc')
    ).valueChanges({idField: 'id'});
  }

  obtenerProductosCategoria(categoria: string) {
    return this.aff.collection('products', ref => ref.where('category', '==', categoria).orderBy('name', 'asc')).valueChanges({idField: 'id'});
  }

  obtenerProveedores() {
    return this.aff.collection('proveedores', ref => ref.orderBy('nombre', 'asc')).valueChanges({idField: 'id'});
  }

  obtenerFolios(id: number) {
    return this.aff.doc<Folio>(`folios/${id}`).valueChanges();
  }

  actualizarFolios(id: number, actual: number) {
    return this.aff.doc(`folios/${id}`).update({actual});
  }

  actualizarRemesa() {
    return this.aff.doc(`boxes/${this.caja.id}`).update({remesas: this.caja.remesas});
  }

  cerrarCaja() {
    return this.aff.doc(`boxes/${this.caja.id}`).update({estado: '1'});
  }

  registrarVenta(venta: Venta) {
    return this.aff.collection('ventas').add(venta);
  }

  actualizarSalida() {
    return this.aff.doc(`boxes/${this.caja.id}`).update({salidas: this.caja.salidas});
  }

  obtenerVendors(estado: boolean): Observable<any> {
    return this.aff.collection('vendors', ref => ref.where('estado', '==', estado)).valueChanges({idField: 'id'});
  }

  crearCaja(caja: Caja) {
    return this.aff.collection('boxes').add(caja);
  }

  imprimir(dteGenerado: DteGenerado) {
    return this.http.post('http://localhost:5000/Printers/print', dteGenerado).toPromise();
  }

  libroDeVenta(dia: string) {

    const headers = new HttpHeaders({
      'Authorization': 'cXBoYXJtYTIwMjA6WA=='
    });

    return this.http.get(`${environment.api}/ventas/libro-ventas/${dia}`, { headers }).toPromise();
  }

  obtenerLibroDeVentas(dia: string) {
    return this.aff.collection(
      'ventas',
      ref => ref
        .where('fecha', '>=', dia + ' 00:00:00')
        .where('fecha', '<=', dia + ' 23:59:59')
        .orderBy('fecha', 'asc')
    ).valueChanges({idField: 'id'}).pipe(take(1));
  }

  async descargarBlob(url: string) {
    return this.http.get(
      url,
      {
        responseType: 'blob'
      }
    ).toPromise();
  }

  obtenerUrl(fileName: string) {
    const ref = this.storage.ref(fileName);
    return ref.getDownloadURL().toPromise();
  }

  async obtenerFiles() {
    const certUrl = await this.obtenerUrl('cert.pfx');
    const certBlob = await this.descargarBlob(certUrl);
    this.cert = new File([certBlob], 'cert.pfx', { type: 'application/x-pkcs12' });

    const cafUrl = await this.obtenerUrl('caf.xml');
    const cafBlob = await this.descargarBlob(cafUrl);
    this.caf = new File([cafBlob], 'caf.xml', { type: 'text/xml' });

  }

  crearProducto(producto: Producto) {
    return this.aff.collection('products').add(producto);
  }

  obtenerImpresora() {
    return this.aff.doc('impresoras/EbjjOIK0l3XQeB73ZzK8').valueChanges().pipe(take(1));
  }

  productoPorNombre(nombre: string) {
    return new Observable<any>();
  }

  detalleProducto(codigo: number) {
    return new Observable<any>();
  }

  folioTBK() {
    return new Observable<any>();
  }

}
